var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callme"},[_c('h2',[_vm._v("联系我们")]),_c('p',[_vm._v("邮箱:2353434162@qq.com")]),_vm._m(0),_c('div',{staticClass:"cancel"},[_c('span',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("取消")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("QQ:2353434162"),_c('span',[_vm._v("加群")])])
}]

export { render, staticRenderFns }